<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-card flat>
      <v-layout justify-start wrap>
        <v-flex xs2 lg2 align-self-start text-left>
          <v-img
            cover
            width="100%"
            :height="$vuetify.breakpoint.name == 'xs' ? '900px' : '800px'"
            :src="require('./../../assets/images/Asset4.png')"
          >
          </v-img>
        </v-flex>
        <v-flex align-self-center xs8 lg8 pt-14>
          <v-layout wrap>
            <v-flex xs12 align-self-center>
              <span
                :class="
                  $vuetify.breakpoint.name == 'xs' ? 'title16xs' : 'title16'
                "
              >
                Contact Us
              </span>
            </v-flex>
            <v-flex xs12 align-self-center>
              <span class="title17"> Get in touch with us </span>
            </v-flex>
            <v-flex xs12 align-self-center py-6>
              <v-form v-model="validates" ref="form">
                <v-layout wrap justify-center>
                  <v-flex xs12 lg6 py-3>
                    <v-text-field
                      color="#F6A448"
                      label="First Name"
                      v-model="firstname"
                      class="textt"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12 lg6 py-3>
                    <v-text-field
                      color="#F6A448"
                      label="Last Name"
                      v-model="lastname"
                      class="textt"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12 lg6 py-3>
                    <v-text-field
                      class="textt"
                      color="#F6A448"
                      v-model="email"
                      :rules="emailRules"
                      label="Email"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12 lg6 py-3>
                    <v-text-field
                      class="textt"
                      color="#F6A448"
                      v-model="message"
                      label="Message"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12 lg6 py-10>
                    <v-btn
                      style="border: 1px solid #e08c1d"
                      rounded
                      plain
                      outlined
                      class="text-capitalize"
                      :disabled="!validates ? true : false"
                      @click="validateInput()"
                      :width="$vuetify.breakpoint.name == 'xs' ? '100%' : '50%'"
                    >
                      <span class="title18"> Submit </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
              <v-layout wrap justify-center pt-sm-2>
                <!-- <v-flex align-self-center lg2 xl1>
                  <v-img
                    contain
                    height="80px"
                    width="80px"
                    :src="require('./../../assets/images/YOTI_Logo.png')"
                  ></v-img>
                </v-flex>
                <v-flex align-self-center lg2 xl1>
                  <v-img
                    contain
                    height="100px"
                    width="100px"
                    :src="require('./../../assets/images/BrightTideLogo.png')"
                  ></v-img>
                </v-flex>
                <v-flex align-self-center lg2 xl1>
                  <v-img
                    contain
                    height="90px"
                    width="100px"
                    :src="require('./../../assets/images/WTILogoHR.png')"
                  ></v-img>
                </v-flex> -->
                <v-flex align-self-center sm5 md4 lg3 xl2>
                  <span
                    v-if="$vuetify.breakpoint.name == 'sm' ? true : false"
                    style="
                      font-family: poppinssemibold;
                      font-size: 14px;
                      color: black;
                    "
                    >Technology Partner</span
                  >
                  <span
                    v-else
                    style="
                      font-family: poppinssemibold;
                      font-size: 18px;
                      color: black;
                    "
                    >Technology Partner</span
                  >
                </v-flex>
                <v-flex align-self-center sm6 md4 lg3 xl2>
                  <v-img
                    contain
                    height="100px"
                    :width="
                      $vuetify.breakpoint.name == 'xs' ||
                      $vuetify.breakpoint.name == 'sm'
                        ? '210px'
                        : '600px'
                    "
                    :src="require('./../../assets/images/LeopardLogo.png')"
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs2 lg2 align-self-start text-right>
          <v-img
            cover
            width="100%"
            :height="$vuetify.breakpoint.name == 'xs' ? '900px' : '800px'"
            class="align-center"
            :src="require('./../../assets/images/Asset4R.png')"
          >
          </v-img>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      vdo: ["./../../assets/videos/Tigers.mp4"],
      flag: true,
      firstname: "",
      lastname: "",
      email: "",
      message: "",
      emailRules: [
        // (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      validates: false,
    };
  },
  methods: {
     resetValidation() {
      this.$refs.form.resetValidation();
    },
    validateInput() {
      if (this.firstname == "") {
        this.msg = "Please provide First Name";
        this.showSnackBar = true;
      } else if (this.lastname == "") {
        this.msg = "Please provide Last Name";
        this.showSnackBar = true;
      } else if (this.email == "") {
        this.msg = "Please provide Email";
        this.showSnackBar = true;
      } else if (this.message == "") {
        this.msg = "Please provide Message";
        this.showSnackBar = true;
      } else this.sendData();
    },
    sendData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/hackathon/contact/add",
        // headers: {
        //   "x-auth-token": localStorage.getItem("token"),
        // },
        data: {
          firstName: this.firstname,
          lastName: this.lastname,
          email: this.email,
          message: this.message,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.allClear();
          this.resetValidation();
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    allClear() {
      this.firstname = "";
      this.lastname = "";
      this.email = "";
      this.message = "";
    },
  },
};
</script>
